// Display individual timesheets -> undispatched jobs -> job requests
export const getJobId = (job) => job.timesheetId || job.jobId || job.id;